const groupMap = {
  100: 80,
  80: 70,
  70: 60,
  60: 40,
  40: 20,
  20: 10
};

export const nextGroup = (group) => groupMap[group];

export const parentGroup = (group) =>
  Object.keys(groupMap)[Object.values(groupMap).indexOf(group)];
